import React from 'react';

import { EmbedCodeSnippetConfig } from './EmbedCodeSnippetConfig';
import { JSONOptionsSnippet } from './JSONOptionsSnippet';

export const VanillaNpmSnippet = ({
  graphRefString,
  persistChangesInEmbedConfig,
  document,
  hideHeadersAndEnvVarsInEmbedConfig,
  headers,
  variables,
  docsPanelState,
  theme,
  autoInviteOptions,
}: EmbedCodeSnippetConfig) => (
  <>
    {`import { ApolloExplorer } from '@apollo/explorer';
  `}
    {`... 
  new ApolloExplorer(`}
    <JSONOptionsSnippet
      persistChangesInEmbedConfig={persistChangesInEmbedConfig}
      hideHeadersAndEnvVarsInEmbedConfig={hideHeadersAndEnvVarsInEmbedConfig}
      headers={headers}
      variables={variables}
      document={document}
      docsPanelState={docsPanelState}
      theme={theme}
      graphRefString={graphRefString}
      autoInviteOptions={autoInviteOptions}
    />
    {`);
  ...
  <div id="embedded-explorer"/>`}
  </>
);
